export const rtkQueryParams = {
  refetchOnMountOrArgChange: true,
};
